const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/6549d97d12a0a90dcc416a6871d6417b.jpeg"
          alt="Altta Talent Studio - Elegancia Contemporánea"
          className="w-full h-full object-cover object-center"
          style={{ imageRendering: 'crisp-edges' }}
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 w-full text-center px-6 py-32">
        <div className="max-w-5xl mx-auto animate-fade-in">
          <div className="flex justify-center mb-8">
            <img 
              src="https://static.readdy.ai/image/eeca736fc8054caf90a8ed02ed251b58/2ae41bce4a3d848cd82a72c84bd5a88c.png"
              alt="Altta Talent Studio"
              className="h-32 lg:h-40 w-auto"
              loading="eager"
            />
          </div>
          <p className="text-2xl lg:text-3xl text-white/95 mb-12 font-light leading-relaxed max-w-3xl mx-auto">
            Talento femenino contemporáneo para marcas que buscan más que una imagen bonita
          </p>
          <div className="flex flex-wrap gap-6 justify-center">
            <a 
              href="#servicios"
              className="bg-[#ffb7b4] text-[#3a3a3a] px-10 py-4 rounded-sm text-lg font-medium hover:bg-[#ffb7b4]/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Descubre Nuestros Servicios
            </a>
            <a 
              href="/contacto"
              className="bg-white/10 backdrop-blur-sm text-white px-10 py-4 rounded-sm text-lg font-medium hover:bg-white/20 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
            >
              Contactar
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
};

export default HeroSection;
